/* KINS · Ficha de producto: selector de presentación, cantidad, agregar al carrito
   (con el carrito lateral del tema), comprar ahora y barra fija. */
(() => {
  const root = document.querySelector('[data-kp-product]');
  if (!root) return;
  const fmt = cents => '$' + Math.round(cents / 100).toLocaleString('es-CO');
  const radios = [...root.querySelectorAll('input[name="id"]')];
  const main = root.querySelector('[data-kp-main-img]');
  const thumbs = [...root.querySelectorAll('[data-kp-thumb]')];
  const form = root.querySelector('form');
  const addBtn = root.querySelector('[data-kp-add]');
  const err = root.querySelector('[data-kp-error]');
  const $ = s => document.querySelectorAll(s);
  let qty = 1;
  // Referencia del ahorro: precio por día de la presentación más corta (misma regla que el Liquid)
  const conDias = radios.filter(x => +x.dataset.days > 0).sort((a, b) => a.dataset.days - b.dataset.days);
  const base = conDias[0] ? { price: +conDias[0].dataset.price, days: +conDias[0].dataset.days } : null;

  const setImg = src => {
    if (!src || main.getAttribute('src') === src) return;
    main.style.opacity = 0;
    setTimeout(() => { main.src = src; main.removeAttribute('srcset'); main.style.opacity = 1; }, 150);
    thumbs.forEach(b => b.setAttribute('aria-current', b.dataset.src === src));
  };

  function update(push) {
    const r = radios.find(x => x.checked) || radios[0];
    const d = r.dataset, price = +d.price, ship = +d.ship, days = +d.days;
    $('[data-kp-price]').forEach(e => e.textContent = fmt(price));
    $('[data-kp-perday]').forEach(e => e.textContent = days ? fmt(Math.round(price / days / 100) * 100) + ' por día' : '');
    $('[data-kp-perday-main]').forEach(e => { e.innerHTML = days ? fmt(Math.round(price / days / 100) * 100) + '<small>/día</small>' : ''; });
    const ref = base && days > base.days && days !== 30 ? Math.round(base.price * days / base.days) : 0, ahorro = ref - price;
    $('[data-kp-save]').forEach(e => { e.hidden = !(ahorro > 0); e.textContent = ahorro > 0 ? 'Ahorras ' + fmt(ahorro) : ''; });
    $('[data-kp-ref]').forEach(e => { e.textContent = ahorro > 0 ? fmt(ref) : ''; });
    $('[data-kp-ref-row]').forEach(e => { e.hidden = !(ahorro > 0); e.title = ahorro > 0 ? 'Precio de ' + Math.round(days / base.days) + ' tarros de ' + base.days + ' días' : ''; });
    $('[data-kp-total-label]').forEach(e => e.textContent = ship ? '+ envío' : 'en total');
    $('[data-kp-ship]').forEach(e => e.textContent = ship ? 'Envío a todo el país: ' + fmt(ship) : 'Envío gratis a todo el país');
    $('[data-kp-subtotal]').forEach(e => e.textContent = fmt(price * qty));
    $('[data-kp-qty]').forEach(e => e.textContent = qty);
    form.querySelector('[name="quantity"]').value = qty;
    const link = '/cart/' + r.value + ':' + qty;
    $('[data-kp-buy]').forEach(a => a.href = link);
    $('[data-kp-sticky-name]').forEach(e => e.textContent = d.name);
    $('[data-kp-sticky-price]').forEach(e => e.textContent = fmt(price * qty));
    $('[data-kp-sticky-img]').forEach(e => e.src = d.img);
    if (push) { const u = new URL(location.href); u.searchParams.set('variant', r.value); history.replaceState(null, '', u); }
  }

  radios.forEach(r => r.addEventListener('change', () => { setImg(r.dataset.img); update(true); }));
  thumbs.forEach(b => b.addEventListener('click', () => setImg(b.dataset.src)));
  root.querySelector('[data-kp-minus]').addEventListener('click', () => { qty = Math.max(1, qty - 1); update(); });
  root.querySelector('[data-kp-plus]').addEventListener('click', () => { qty = Math.min(10, qty + 1); update(); });

  // Agregar al carrito con el carrito lateral / notificación del tema
  form.addEventListener('submit', e => {
    e.preventDefault();
    if (addBtn.getAttribute('aria-disabled') === 'true') return;
    addBtn.setAttribute('aria-disabled', 'true'); err.hidden = true;
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const fd = new FormData(form);
    if (cart && cart.getSectionsToRender) {
      fd.append('sections', cart.getSectionsToRender().map(s => s.id));
      fd.append('sections_url', location.pathname);
      cart.setActiveElement && cart.setActiveElement(document.activeElement);
    }
    fetch((window.routes && routes.cart_add_url) || '/cart/add', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd })
      .then(r => r.json())
      .then(res => {
        if (res.status) { err.textContent = res.description || 'No se pudo agregar al carrito.'; err.hidden = false; return; }
        if (!cart) { location.href = (window.routes && routes.cart_url) || '/cart'; return; }
        cart.classList.remove('is-empty');
        cart.renderContents(res);
      })
      .catch(() => { form.submit(); })
      .finally(() => addBtn.removeAttribute('aria-disabled'));
  });

  update();

  // Barra fija cuando la caja de compra sale de pantalla
  const sticky = document.querySelector('[data-kp-sticky]');
  if (sticky) new IntersectionObserver(([en]) => {
    const show = !en.isIntersecting && en.boundingClientRect.top < 0;
    sticky.classList.toggle('show', show); sticky.setAttribute('aria-hidden', String(!show));
    document.documentElement.style.setProperty('--kins-wa-sube', show ? sticky.offsetHeight + 'px' : '0px'); /* WhatsApp sube sobre la barra (kins-r.js) */
  }).observe(form);
})();
